import React from 'react';
import styled, { css } from 'styled-components';

import settings from '../config/settings';

const Nav = styled.nav`
  margin: 1em 0;
  ul {
    line-height: 1em;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  ${props => props.inline && css`
    li {
      display: inline-block;
      padding: 0 0.25em;
    }
  `}
  a {
    color: #CCCCCC;
    ${props => props.navBlock && css`
      border-radius: ${settings.borderRadius};
      display: block;
      padding: 0.75em;
      text-decoration: none;
      transition: 250ms linear background-color;
      &:hover {
        background-color: #666666;
      }
    `}
  }
`;

export default (props) => (
  <Nav {...props}>
    <ul>
      {props.children}
    </ul>
  </Nav>
);



// WEBPACK FOOTER //
// ./src/components/Nav.js